import { render, staticRenderFns } from "./promo-create-v3.vue?vue&type=template&id=1de3bc69&scoped=true"
import script from "./promo-create-v3.vue?vue&type=script&lang=js"
export * from "./promo-create-v3.vue?vue&type=script&lang=js"
import style0 from "./promo-create-v3.vue?vue&type=style&index=0&id=1de3bc69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de3bc69",
  null
  
)

export default component.exports